import "./App.css";
import "react-notifications/lib/notifications.css";
import MainLayout from "./layouts/MainLayout";
import { Provider } from "react-redux";
import store from "./reducer";
import { HashRouter } from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import { createMuiTheme, ThemeProvider } from "@material-ui/core";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#cc7000',
      contrastText:'white'
    },
  },
});

function App() {
  return (
    <div dir="rtl" className="App">
      <NotificationContainer />
      <ThemeProvider theme={theme}>
        <HashRouter>
          <Provider store={store}>
            <MainLayout />
          </Provider>
        </HashRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
